import { getCategoryMetadata } from '../../../shared/helpers/categoryHelpers';
import { AgeLimitLabel } from '../../AgeLimitLabel/AgeLimitLabel';
import { formatDate } from '../../../helpers/date';

import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';
import type { ReactNode } from 'react';

export const getCategoryLabels = (
  category: SvpCategoryAdditional,
  parentCategory?: SvpCategoryAdditional
) => {
  const seriesRelease = getCategoryMetadata(category).series_releasedAt?.value;
  const labels: ReactNode[] = [
    parentCategory?.title,
    seriesRelease
      ? formatDate(parseInt(seriesRelease, 10) * 1000, 'YYYY')
      : undefined,
    ![null, undefined].includes(category.ageLimit as any) && (
      <AgeLimitLabel ageLimit={category.ageLimit} />
    ),
  ];

  return labels.filter(Boolean);
};
